import React, { useState } from "react";
import { IoInformationCircleOutline } from "react-icons/io5";
import Divider from "@mui/material/Divider";
import Tooltip from "../../../../../../Components/Tooltip/Tooltip";
import UnitSwitch from "./UnitSwitch";
import PackageList from "./PackageList";
import ProductList from "./ProductList";
import Buttons from "./Buttons";
import { formatMoney } from "../../../../../../helpers/money";
import "./Package.css";
import { Stack, Typography, IconButton } from "@mui/material";

export default function Package(props) {
  const {
    Plist,
    StepCheck,
    SetStepCheck,
    SetPlist,
    Alist,
    SetAlist,
    Stepper,
    SelectedProducts,
    setSelectedProducts,
    setbundleRefresh,
    setpackageRefresh,
  } = props;
  const [bundleShow, setbundleShow] = useState(false);
  const handleBundleShow = () => {
    setbundleShow(!bundleShow);
  };

  return (
    // data-ship-step: the progress rail places its step beside this card
    <div className="card bg-ui-surface shadow wapper_like_shopify" data-ship-step="packages">
      <div className="card-header package__dimension_header_wrap">
        <div className="package__dimension_header_content">
          <span>DIMENSIONS & WEIGHT</span>
          <Tooltip title="Details Of The Package you Want to Ship">
            <IconButton>
              <IoInformationCircleOutline size={15} />
            </IconButton>
          </Tooltip>
        </div>

        <div className="package__dimension_unit package__unit_btn_wrap">
          <span>Unit</span>
          <UnitSwitch
            List={StepCheck}
            SetList={SetStepCheck}
            SetPlist={SetPlist}
          />
        </div>

        <div className="package__dimension_unit_bundle_btn">
          {SelectedProducts.length <= 0 && (
            <div className="package__dimension_wrap dimension_weight_card_wrap">
              <div className="package__dimension_weight_volume">
                <div className="package__dimension_weight_volume_label">
                  <div className="package__dimension_weight">
                    <span>Weight</span>
                    <small style={{ whiteSpace: "nowrap" }}>
                      {parseFloat(StepCheck["TotalWeight"] ?? 0).toFixed(2)}{" "}
                      {StepCheck["unit"] === "Imperial" ? "lb" : "kg"}
                    </small>
                  </div>
                  <div className="package__dimension_volume">
                    <span>Volume</span>
                    <small style={{ whiteSpace: "nowrap" }}>
                      {parseFloat(StepCheck["TotalVolume"] ?? 0).toFixed(2)}{" "}
                      {StepCheck["unit"] === "Imperial" ? "Cbm" : "Cbf"}
                    </small>
                  </div>
                  <div className="package__dimension_volume">
                    <span>Fulfilment Cost</span>
                    <small style={{ whiteSpace: "nowrap" }}>
                      {formatMoney(StepCheck["TotalFulfilmentCost"] ?? 0)}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          )}

          {Stepper["Packages"] === 1 && StepCheck["Packages_bit"] === 0 && (
            <div className="package__dimension_weight_btn">
              <Buttons
                Name="Create A Bundle"
                Variant="contained"
                Color="primary"
                HandleChange={handleBundleShow}
                className="make__bundle_btn"
                Sx={{
                  backgroundColor: "var(--color-brand) !important",
                  color: "var(--color-brand-contrast) !important",
                  "&:hover": {
                    backgroundColor: "var(--color-brand-hover) !important",
                  },
                }}
              />
            </div>
          )}
        </div>
      </div>
      <div className="card-body dimension_weight_card_body">
        {StepCheck["Warehouses"] && SelectedProducts.length > 0 && (
          <>
            <ProductList
              Plist={Plist}
              SetPlist={SetPlist}
              StepCheck={StepCheck}
              SetStepCheck={SetStepCheck}
              SelectedProducts={SelectedProducts}
              setSelectedProducts={setSelectedProducts}
            />
            <Divider component="li" style={{ marginBottom: "25px" }} />
          </>
        )}

        <PackageList
          Plist={Plist}
          SetPlist={SetPlist}
          SelectedProducts={SelectedProducts}
          Alist={Alist}
          StepCheck={StepCheck}
          SetStepCheck={SetStepCheck}
          setpackageRefresh={setpackageRefresh}
          bundleShow={bundleShow}
          setbundleShow={setbundleShow}
          setbundleRefresh={setbundleRefresh}
        />

        {StepCheck["TotalWeight"] > 0 && StepCheck["QuoteCheck"] === false && (
          <>
            <Stack
              direction="row"
              spacing={1}
              justifyContent="center"
              mt={2}
              mb={2}
              sx={{ width: "100%" }}
            >
              <Buttons
                Name="Request A Quote"
                Variant="contained"
                Color="primary"
                TYPE="quote"
              />
            </Stack>
          </>
        )}
      </div>
    </div>
  );
}
